import * as React from 'react';

const ABSegmentContext = React.createContext({});

export const ABSegmentContextProvider = ABSegmentContext.Provider;
export default ABSegmentContext;
